import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { lineClamp } from 'components/Common/GlobalStyles'
import { useChapterIcon } from '../../_methods'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  color: var(--grey-white, #fff);
`

const BreadcrumbText = styled.span``

const BreadcrumbLink = styled(Link)`
  color: var(--grey-white, #fff);
  text-decoration: none;
`

const Separator = styled.span`
  margin: 0 8px;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    color: var(--color-white);
    width: 100%;
    height: 100%;
  }
`

const Crumbs = styled.div`
  display: block;
  font: var(--typography-12-16-regular);

  ${lineClamp()}
`

const Breadcrumbs = ({ items, icon }) => {
  const breadcrumbsItems = items || []
  const Icon = useChapterIcon(icon)

  return (
    <Wrapper data-testid='breadcrumbs'>
      {Icon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}

      <Crumbs>
        {breadcrumbsItems.map((item, index) => (
          <Fragment key={item?.name || index}>
            {index > 0 && <Separator>/</Separator>}

            {item?.link && index !== breadcrumbsItems.length - 1 ? (
              <BreadcrumbLink to={item.link} data-testid={item?.testId}>
                {item?.name}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbText data-testid={item?.testId}>
                {item?.name}
              </BreadcrumbText>
            )}
          </Fragment>
        ))}
      </Crumbs>
    </Wrapper>
  )
}

export default Breadcrumbs
